<!--
  LoadingModal.vue
  処理中表示モーダル
-->
<template>
  <ModalBase
    :title="dispTitle"
    :isShowModal="isShowModal"
    :canCancel="false"
    :close="modalClose"
    :width="'550px'"
    :height="'200px'"
  >
    <div class="card -card">
      <!-- 処理中メッセージ表示 -->
      <b-message type="is-info" has-icon>
        <p v-html="dispMessage"></p>
        <span class="mdi mdi-loading mdi-spin"></span>
      </b-message>
    </div>
  </ModalBase>
</template>

<script>
// モーダルベース
import ModalBase from '@/hrm-frontend/views/atomic/screen-components/basic-components/base-modal/ModalBase'

export default {
name: 'LoadingModal',
componentName: 'LoadingModal',
components: {
    // モーダルベース
    ModalBase,
  },
props: {
  /**
   * モーダル表示フラグ
   * @type {Boolean}
   */
  isShowModal: {
    type: Boolean,
    required: true,
    default: false,
  },
  /**
   * 表示タイトル
   * @type {String}
   */
  dispTitle: {
    type: String,
    required: false,
    default: '処理中です...',
  },
  /**
   * 表示メッセージ
   * @type {String}
   */
  dispMessage: {
    type: String,
    required: false,
    default: '処理中です...',
  },
},
data() {
  return {
    /**
     * モーダル表示フラグ
     * @type {Boolean}
     */
    isShowModalSync: this.isShowModal,
  }
},
watch: {
  /**
   * モーダル表示
   */
  isShowModal() {
    this.isShowModalSync = this.isShowModal
  },
},
methods: {
  /**
   * モーダルクローズ
   */
  modalClose () {
    isShowModal = false
  }
}
}
</script>

<style lang="scss" scoped>
// モーダル
.-card {
  width: 550px;
  height: 300px;
}
</style>


// WEBPACK FOOTER //
// src/hrm-frontend/views/atomic/screen-components/purpose_components/common-components/LoadingModal.vue